export const consumerPreference = {
  "tab_name": "consumer-preference",
  "data": [
    {
      "name": "University of Brighton",
      "series": [
        {
          "name": "Student Satisfaction",
          "value": 85.0
        },
        {
          "name": "Career Outcomes",
          "value": 90.0
        },
        {
          "name": "Learning Experience",
          "value": 88.0
        },
        {
          "name": "Value for Money",
          "value": 75.0
        },
        {
          "name": "International Recognition",
          "value": 92.0
        }
      ]
    },
    {
      "name": "University of Central Lancashire",
      "series": [
        {
          "name": "Student Satisfaction",
          "value": 85.0
        },
        {
          "name": "Career Outcomes",
          "value": 90.0
        },
        {
          "name": "Learning Experience",
          "value": 88.0
        },
        {
          "name": "Value for Money",
          "value": 75.0
        },
        {
          "name": "International Recognition",
          "value": 92.0
        }
      ]
    },
    {
      "name": "University of Hull",
      "series": [
        {
          "name": "Student Satisfaction",
          "value": 85.0
        },
        {
          "name": "Career Outcomes",
          "value": 90.0
        },
        {
          "name": "Learning Experience",
          "value": 88.0
        },
        {
          "name": "Value for Money",
          "value": 75.0
        },
        {
          "name": "International Recognition",
          "value": 92.0
        }
      ]
    },
    {
      "name": "University of Salford",
      "series": [
        {
          "name": "Student Satisfaction",
          "value": 85.0
        },
        {
          "name": "Career Outcomes",
          "value": 90.0
        },
        {
          "name": "Learning Experience",
          "value": 88.0
        },
        {
          "name": "Value for Money",
          "value": 75.0
        },
        {
          "name": "International Recognition",
          "value": 92.0
        }
      ]
    },
    {
      "name": "University of West London",
      "series": [
        {
          "name": "Student Satisfaction",
          "value": 85.0
        },
        {
          "name": "Career Outcomes",
          "value": 90.0
        },
        {
          "name": "Learning Experience",
          "value": 88.0
        },
        {
          "name": "Value for Money",
          "value": 75.0
        },
        {
          "name": "International Recognition",
          "value": 92.0
        }
      ]
    }
  ],
  "evidence_sources": [
    {
      "category": "consumer_survey",
      "source": "Student Satisfaction Survey",
      "confidence": 0.88,
      "url": "https://www.officeforstudents.org.uk/advice-and-guidance/student-information-and-data/national-student-survey-nss/",
      "snippet": "Annual survey of final-year undergraduate students measuring satisfaction with their course.",
      "type": "survey",
      "domain": "education"
    },
    {
      "category": "career_outcomes",
      "source": "Graduate Employment Survey",
      "confidence": 0.85,
      "url": "https://www.hesa.ac.uk/data-and-analysis/graduates",
      "snippet": "Survey tracking graduate employment outcomes and career progression after university.",
      "type": "survey",
      "domain": "employment"
    }
  ],
  "recommendations": [
    {
      "category": "student_experience",
      "issue": "Student Satisfaction Improvement",
      "recommendation": "Enhance student support services and learning resources to improve satisfaction scores",
      "priority": "High",
      "expected_impact": "Increase student satisfaction scores by 3-5 points"
    },
    {
      "category": "career_support",
      "issue": "Career Development",
      "recommendation": "Strengthen career counseling and industry placement programs",
      "priority": "Medium",
      "expected_impact": "Improve career outcomes by 2-4 points"
    }
  ],
  "cached": false,
  "timestamp": "2025-08-19T18:35:13.844800",
  "models_used": [
    "chatgpt"
  ],
  "plan_type": "university_paid"
};
